import { Plus, Trash2, MessageSquare } from "lucide-react";
import { useRag } from "../RagContext";
import "./ConversationSidebar.css";

export default function ConversationSidebar() {
    const {
        conversations,
        currentConversationId,
        currentBandoId,
        loading,
        selectConversation,
        createConversation,
        deleteConversation,
    } = useRag();

    const handleDeleteConversation = (e, id) => {
        e.stopPropagation();
        if (window.confirm("Eliminare questa conversazione?")) {
            deleteConversation(id);
        }
    };

    return (
        <aside className="rag-sidebar">
            <button
                className="rag-sidebar__new-conv"
                onClick={() => createConversation(currentBandoId || null)}
                disabled={!currentBandoId}
                title={!currentBandoId ? "Seleziona prima un bando" : "Nuova conversazione"}
            >
                <Plus size={16} />
                <span>Nuova conversazione</span>
            </button>

            <div className="rag-sidebar__list">
                {loading.conversations ? (
                    <p className="rag-sidebar__empty">Caricamento…</p>
                ) : conversations.length === 0 ? (
                    <p className="rag-sidebar__empty">
                        {currentBandoId ? "Nessuna conversazione" : "Seleziona un bando"}
                    </p>
                ) : (
                    conversations.map((conv) => {
                        const isActive = currentConversationId === conv.id;
                        return (
                            <div
                                key={conv.id}
                                className={`rag-sidebar__item ${isActive ? "rag-sidebar__item--active" : ""}`}
                                onClick={() => selectConversation(conv.id)}
                            >
                                <MessageSquare size={14} className="rag-sidebar__item-icon" />
                                <span className="rag-sidebar__item-title">
                                    {conv.title || "Nuova conversazione"}
                                </span>
                                <button
                                    type="button"
                                    className="rag-sidebar__delete"
                                    aria-label="Elimina conversazione"
                                    onClick={(e) => handleDeleteConversation(e, conv.id)}
                                >
                                    <Trash2 size={12} />
                                </button>
                            </div>
                        );
                    })
                )}
            </div>
        </aside>
    );
}
